exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#header[data-v-68c23267] {\n  position: fixed;\n  background-color: #212121;\n  left: 0;\n  right: 0;\n  top: 0;\n  z-index: 500;\n}\n#member_logo[data-v-68c23267] {\n  cursor: pointer;\n}", ""]);

// exports
